import { useEffect, useMemo, useState } from 'react';
import airkeyTagLight from '@assets/airkeyTag.svg';
import airkeyTagDark from '@assets/airkeyTag-dark.svg';

export function useThemeAssets() {
  const [isDarkMode, setIsDarkMode] = useState(
    () => window.matchMedia('(prefers-color-scheme: dark)').matches,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e: MediaQueryListEvent) => setIsDarkMode(e.matches);

    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return useMemo(
    () => ({
      airkeyTag: isDarkMode ? airkeyTagDark : airkeyTagLight,
      // add more assets here as needed
    }),
    [isDarkMode],
  );
}
